import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MessagePlugin } from 'tdesign-react';

import { HomeDataManagerType } from '@/const/promotion';
import { IBot } from '@/interface';
import { CgiErrorCode } from '@/services/cgi';
import { fetchPlazaDetail } from '@/services/plaza';

interface StateInfo {
  id?: string;
  name?: string;
  plazaList?: {
    homeDataId?: string;
    managerType?: HomeDataManagerType
    style?: HomeDataManagerType;
    id?: string;
    bots?: IBot[];
  }[];
  materialMap: Record<string, string>
}

export interface PlazaState {
  plazaInfo: StateInfo,
  loading: boolean;
}

const initialState: PlazaState = {
  plazaInfo: {
    plazaList: [],
    materialMap: {},
  },
  loading: false,
};

export const getPlazaDetail = createAsyncThunk('plaza/detail', fetchPlazaDetail);
export const plaza = createSlice({
  name: 'basic',
  initialState,
  reducers: {
    initPlaza() {
      return {
        ...initialState,
      };
    },
    updatePlazaInfo(state, action) {
      state.plazaInfo = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPlazaDetail.fulfilled, (state, { payload }) => {
      if (payload?.code !== CgiErrorCode.NO_ERROR) {
        MessagePlugin.error(payload?.message || '请求失败，请重试');
        return ({
          ...state,
          loading: false,
        });
      }
      return ({
        ...state,
        loading: false,
        plazaInfo: payload?.data as StateInfo,
      });
    });
  },
});

export const { updatePlazaInfo, initPlaza, setLoading } = plaza.actions;

export default plaza.reducer;
